module.exports = __webpack_public_path__ + "static/media/completeResignation.c3733064.svg";